import CMSCollection from './CMSCollection.vue'
// import CMSSlider from './CMSSlider.vue'
import CMSScrollableLink from './CMSScrollableLink.vue'
import CMSEffect from './CMSEffect.vue'
import CMSJobOpening from './CMSJobOpening.vue'
import CMSTrustPilot from './CMSTrustPilot.vue'
import CMSTrustPilot2025 from './CMSTrustPilot2025.vue'
import CMSTrustPilotService from './CMSTrustPilotService.vue'
import CMSPowerBar from './CMSPowerBar.vue'
// import CMSStoreSelector from './CMSStoreSelector.vue'
// import CMSStoreListing from './CMSStoreListing.vue'
import SimpleLightbox from './simple-lightbox.js'
import moment from 'moment'
import SwiperCore, { Navigation, Mousewheel } from 'swiper/core'
import Swiper from 'swiper';
import CMSComponentsConfig from './json/cms-components-config'
import { ScrollViewAnimation, VideoLottie } from './view-animation'

Vue.prototype.moment = moment

SwiperCore.use([Navigation, Mousewheel])

require('./simple-lightbox.scss')
require('intersection-observer')
require('./lib/scrollToAnmiate.js')
require('./lib/aos/sass/aos.scss')
require('./cms-custom-components.js')

const supportWebp = document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp;') === 0

CMSInit()

if (window.Server && Server.sgmtIds) {
  let style = document.createElement('style')
  let styleText = ''
  Server.sgmtIds.split(',').forEach(id => {
    styleText = `${styleText}.cms-page-container section[data-segment-ids*="_${id}_"] { display: block; } `
  })
  style.innerHTML = styleText
  document.body.appendChild(style)
}

// const CDNPath = path => {
//   if (path.startsWith('http://') || path.startsWith('https://')) return path
//   if (!window.ConstantsManager || !window.ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN) return path
//   if (!path.startsWith('/')) path = `${path}/`
//   return `https://${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}${path}`
// }
const CDNPath = (src, imgSettings = null) => {

  if (null === imgSettings) {

    if (src.startsWith('http://') || src.startsWith('https://')) {

      if (ConstantsManager.S3_URL_PREFIX && ConstantsManager.S3_URL_PREFIX_HTTPS && ConstantsManager.S3_CDN_URL_PREFIX) {

        // if someone accidentially uses a non-CDN S3 bucket
        // replace it automatically

        if (src.startsWith(ConstantsManager.S3_URL_PREFIX)) {
          return src.replace(ConstantsManager.S3_URL_PREFIX, ConstantsManager.S3_CDN_URL_PREFIX)
        }
        if (src.startsWith(ConstantsManager.S3_URL_PREFIX_HTTPS)) {
          return src.replace(ConstantsManager.S3_URL_PREFIX_HTTPS, ConstantsManager.S3_CDN_URL_PREFIX)
        }

      }

      return src // do nothing for external images
    }

    return `//${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}${src}`

  } else {
    src = src.replace(/^http(s?):\/\//, '/')
  }

  let { type = 'local', format = 'jpg', colors = '0', depth = '0', sizing = '100' } = imgSettings
  let path = 'optim'
  if (type === 's3' || type === 'proxy') path = 'proxy'

  // @TODO - use image02
  return `//${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}/img-${path}/${format}/${colors}/${depth}/${sizing}${src}`

}
// Vue.config.devtools = process.env.NODE_ENV !== 'production'

function CMSInit() {

  // Tracking
  let itemOptionTracked = {}
  Array.from(document.querySelectorAll('[href^="#fn:waitlist:"]')).forEach(initTracking)
  function initTracking(el) {
    let href = el.getAttribute('href')
    let re = /#fn:waitlist:([0-9]+)/
    let result = re.exec(href)
    if (result && result[1]) {
      if (itemOptionTracked[result[1]]) return
      itemOptionTracked[result[1]] = 1
      let api = `//${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}/api-cache/1h/ItemOption?fn=getItemOptionById&id=${result[1]}`
      fetch(api).then(res => res.json())
        .then(res => {
          if (res && res.itemOption) {
            let dummyArtworkId = '6292265'
            let name = res.itemOption.description
            let sku = ConstantsManager.PRODUCT_SKU_CODE_PREFIX + '-' + dummyArtworkId + '-' + res.itemOption.id
            let product = {
              'name': name,
              'id': sku,
            }
            let item_category = ''
            if (res.tags[res.itemOption.id] && res.tags[res.itemOption.id]['item_category']) {
              item_category = res.tags[res.itemOption.id]['item_category'][0]
            }
            if (item_category) {
              product.category = item_category
            }

            window.dataLayer && window.dataLayer.push({
              'ecommerce': {
                'detail': {
                  'currencyCode': window.Server.currency,
                  'products': [product]
                }
              }
            })

            window.dataLayer && window.dataLayer.push({
              'event': 'view_content',
            })
          }
        })
    }
  }

  // Collections
  Array.from(document.querySelectorAll('.cms-page-container vue-collection')).forEach(initCollection)
  function initCollection(el) {
    new Vue({
      el : el,
      render : h => h(CMSCollection, {
        props: {
          mode : el.dataset.mode,
          custom : {
            title : el.dataset.customTitle || null,
            items : parseItems(el.dataset.customImages, el.dataset.customAttributes)
          },
          boundCollection : {
            collectionId : el.dataset.collectionId || null,
            displayCount : (el.dataset.displayCount && +el.dataset.displayCount) || null,
            displayHeader : !!el.dataset.displayHeader,
            displayPrice : !!el.dataset.displayPrice,
            titleAlignment : el.dataset.titleAlignment || 'left',
          },
          sliderMode : !!el.dataset.sliderMode,
          initSwiper : initSwiper
        }
      })
    })

    function parseItems(images, attributes) {
      if (!images || !attributes) return []
      images = JSON.parse(decodeURIComponent(images))
      attributes = JSON.parse(decodeURIComponent(attributes))
      return attributes.map((attr, index) => {
        return { image : images[index], ...attr }
      })
    }
  }

  // Sliders

  {
    async function getComponent() {

      let CMSSlider = await import(/* webpackChunkName: 'cms-slider' */ './CMSSlider.vue')
      return CMSSlider
    }

    if (document.querySelector('.cms-page-container vue-slider')) {
      getComponent().then(CMSSlider => {
        Array.from(document.querySelectorAll('.cms-page-container vue-slider')).forEach(el => {
          new Vue({
            el,
            render : h => h(CMSSlider, {
              props: {
                sizing : el.dataset.sizing,
                autoLoop : !!el.dataset.autoLoop,
                slideConfig : JSON.parse(el.dataset.slideConfig),
                layoutMode : el.dataset.layoutMode || 'banner'
              }
            })
          })
        })
      })
    }
  }

  // Array.from(document.querySelectorAll('.cms-page-container vue-slider')).forEach(initSlider)
  // function initSlider(el) {
  //   new Vue({
  //     el : el,
  //     render : h => h(CMSSlider, {
  //       props: {
  //         sizing : el.dataset.sizing,
  //         autoLoop : !!el.dataset.autoLoop,
  //         slideConfig : JSON.parse(el.dataset.slideConfig),
  //         layoutMode : el.dataset.layoutMode || 'banner'
  //       }
  //     })
  //   })
  // }

  // Videos
  var videoFn
  var videos = Array.from(document.querySelectorAll('.cms-page-container video[data-auto-play]'))

  function playVideoInView() {

    videoFn && clearTimeout(videoFn)
    videoFn = setTimeout(doPlayVideo, 50)

    let margin = window.innerHeight * .3

    function doPlayVideo() {
      videos.forEach(video => {
        if (isScrolledIntoViewAndVisible(video)) {
          if (video.paused) video.play()
        } else video.pause()
      })
    }

    function isScrolledIntoViewAndVisible(el) {
      if (el.clientWidth === 0) return false
      var elemTop = el.getBoundingClientRect().top;
      var elemBottom = el.getBoundingClientRect().bottom;
      var isVisible = elemTop < (window.innerHeight - margin) && elemBottom > margin;
      return isVisible;
    }
  }

  if (videos.length) {
    window.addEventListener('scroll', playVideoInView)
    window.addEventListener('resize', playVideoInView)
    playVideoInView()
  }

  // Scrollable Links
  Array.from(document.querySelectorAll('.cms-page-container vue-scrollable-links')).forEach(initScrollableLink)
  function initScrollableLink(el) {
    new Vue({
      el : el,
      render : h => h(CMSScrollableLink, {
        props: {
          itemsPerPage : el.dataset.itemsPerPage,
          linkTarget : el.dataset.linkTarget || false,
          itemWidthMobile : el.dataset.itemWidth || 75,
          imageAspectRato : el.dataset.imageAspectRatio || 56.25,
          imageLazyLoading : el.dataset.imageLazyLoading || 'No',
          slideConfig : JSON.parse(el.dataset.slideConfig)
        }
      })
    })
  }

  // Effect Blocks
  Array.from(document.querySelectorAll('.cms-page-container .effect-container')).forEach(initEffectContainer)
  function initEffectContainer(el) {

    let fnScroll = event => {
      let boundingRect = el.getBoundingClientRect()
      let { top, bottom, height } = boundingRect

      // console.dir(boundingRect)

      if (top > window.innerHeight) return vueEventHub.$emit('intersection-update', {
        progress : 0
      })

      if (bottom < window.innerHeight - height) return vueEventHub.$emit('intersection-update', {
        progress : 1
      })

      let upperProgress = (window.innerHeight - top) / window.innerHeight
      let lowerProgress = (window.innerHeight - bottom) / window.innerHeight
      let overallProgress = (upperProgress + lowerProgress) /2

      if (overallProgress < 0) overallProgress = 0
      else if (overallProgress > 1) overallProgress = 1

      // console.log(upperProgress, lowerProgress, overallProgress)

      vueEventHub.$emit('intersection-update', {
        container : el,
        progress : overallProgress
      })
    }

    window.addEventListener('scroll', fnScroll, { passive: true })

  }

  Array.from(document.querySelectorAll('.cms-page-container vue-effect-layer')).forEach(initEffectLayer)
  function initEffectLayer(el) {

    let props = {
      effect : el.dataset.effect,
      from : parseFloat(el.dataset.from),
      to : parseFloat(el.dataset.to),
      image : el.dataset.image,
      placement : el.dataset.placement,
      imageWidth : el.dataset.imageWidth || 'auto',
      offset : el.dataset.offset? el.dataset.offset.split(',') : false,
      container : el.parentNode // = the effect container
    }

    new Vue({
      el : el,
      render : h => h(CMSEffect, { props })
    })
  }

  if (document.querySelector('vue-job-opening')) {

    let props = {
      id : window.location.hash? parseInt(window.location.hash.replace('#', ''), 10) : null
    }

    new Vue({
      el : document.querySelector('vue-job-opening'),
      render : h => h(CMSJobOpening, { props })
    })

  }

  Array.from(document.querySelectorAll('.cms-page-container .cms-sliding-image-block')).forEach(initSwiper)

  function initSwiper(el) {

    let images = Array.from(el.querySelectorAll(`[data-zoomed-src]`))
    let maxHeight = el.dataset['imageHeight'] || '300'
    images.forEach(img => {
      let src = img.dataset['zoomedSrc'].replace(/^http(s?):\/\//, 'https://' + ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN + `/img-proxy/${supportWebp? "webp" : "jpg"}/0/0/x${maxHeight}/`)
      img.src = src
    })

    // Init Slider
    const container = el.querySelector('.swiper-container')
    const nextEL = el.querySelector('.swiper-button-next')
    const prevEL = el.querySelector('.swiper-button-prev')
    if (container) {
      function updateSlideSize () {
        Array.from(el.querySelectorAll('.swiper-slide')).map(slide => {
          const elHeight = slide.getBoundingClientRect().width;
          if (elHeight && slide.querySelector('img.slide-image')) {
            slide.querySelector('img.slide-image').style.height = `${elHeight}px`
          }
        })
      }
      new Swiper(container, {
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 9,
        grabCursor: true,
        loop: true,
        mousewheel: {
          forceToAxis: true
        },
        breakpoints: {
          768: {
            centeredSlides: false,
            slidesPerView: 4,
            spaceBetween: 16,
            width: null
          }
        },
        navigation: {
          nextEl: nextEL,
          prevEl: prevEL,
        },
        on: {
          resize: function () {
            updateSlideSize()
          },
          afterInit: function () {
            updateSlideSize()
          }
        }
      })
    }
    // Lightbox fallback
    if (Array.from(el.querySelectorAll('a.lightbox-image')).length > 0) {
      new SimpleLightbox(el.querySelectorAll('a.lightbox-image'), {
        captionSelector: 'self',
        animationSpeed: 100,
        history: false,
        showCounter: false
      })
    }
  }


  // Special functions (e.g. waitlist)
  if (document.readyState === 'complete') hookCMSFunctions()
  else document.addEventListener('DOMContentLoaded', hookCMSFunctions, { once: true })

  function hookCMSFunctions() {
    let el = Array.from(document.querySelectorAll('a[href^="#fn:"]'))
    let functionParser = require('./functionParser.js')
    el.forEach(node => {
      let [, functionName, ...params] = node.getAttribute('href').split(':')
      functionParser(node, functionName, params)
    })
  }

  // PDP 2020, if bLazy is not loaded, directly swap the image
  if (!window.bLazy) {
    Array.from(document.querySelectorAll('.cms-page-container img.b-lazy[data-src]')).forEach(loadImage)
  }

  function loadImage(img) {
    img.loading = 'lazy'
    img.src = img.dataset['src']
  }

  // TrustPilot (override Yotpo)
  Array.from(document.querySelectorAll('#yotpo-cms-container')).forEach(loadTrustPilot);

  function getTrustPilotComponent() {
    if (window.location.search.includes('layout=2025')) {
        console.log('2025 review')
        return CMSTrustPilot2025
      } else {
        return CMSTrustPilot
      }
  }

  function loadTrustPilot(el){
    let artworkId = window.Server && Server.artworkId
    if (!artworkId) artworkId = document.body.dataset['artworkId'] || null // PDP 2020

    let itemOption = window.detailsPageState? detailsPageState.get('currentItem').type_id : null // old PDP
    if (itemOption === null) itemOption = document.body.dataset['itemOptionId'] || null // PDP 2020

    let sku = `CTF-${artworkId}-${itemOption}`
    new Vue({
      el : el,
      render : h => h(getTrustPilotComponent(), {
        props: {
          sku : sku,
          CDNPath
        }
      })
    })
  }

  if (document.querySelector('vue-trustpilot-service')) {
    new Vue({
      el : document.querySelector('vue-trustpilot-service'),
      render : h => h(CMSTrustPilotService, {
        props: {}
      })
    })
  }

  // Yotpo
  // if (!!document.querySelector('#yotpo-cms-container')) {

  //   window.vueEventHub && window.vueEventHub.$emit('disable-detail-page-product-review')

  //   setTimeout(() => {

  //     document.querySelector('#yotpo-cms-container').innerHTML = `<div class="yotpo yotpo-main-widget"></div>`

  //     let fn = Promise.resolve()
  //     let pause = new Promise(r => { setTimeout(r, 10) })

  //     let el = document.querySelector('#yotpo-cms-container .yotpo-main-widget')
  //     el.innerHTML = ''
  //     el.dataset.yotpoElementId = null
  //     let artworkId = window.Server && Server.artworkId
  //     if (!artworkId) artworkId = document.body.dataset['artworkId'] || null // PDP 2020

  //     let itemOption = window.detailsPageState? detailsPageState.get('currentItem').type_id : null // old PDP
  //     if (itemOption === null) itemOption = document.body.dataset['itemOptionId'] || null // PDP 2020

  //     el.dataset['productId'] = `CTF-${artworkId}-${itemOption}`
  //     el.dataset['name'] = window.Server && Server.currentArtwork && Server.currentArtwork.art_work_name
  //     el.dataset['url'] = window.location.href
  //     // el.dataset['image-url'] = ``
  //     // el.dataset['description'] = ``

  //     let firstLoad = false
  //     if (typeof yotpo === 'undefined') {
  //       firstLoad = true
  //       fn = Util.loadScript(`//staticw2.yotpo.com/${ConstantsManager.YOTPO_APP_KEY}/widget.js`)
  //     }

  //     fn.then(() => {
  //       if (artworkId === null) throw new Error(`YOTPO: cannot resolve item artwork ID`)
  //       if (itemOption === null) throw new Error(`YOTPO: cannot resolve item option ID`)
  //       yotpo.pageSku = `CTF-${artworkId}-${itemOption}`
  //     })
  //     .then(pause)
  //     .then(() => {
  //       if (!firstLoad) yotpo.refreshWidgets()
  //       var starStringCallback = function () {
  //         var starAndReviewEl = document.querySelector('#yotpo-cms-container .yotpo-main-widget .yotpo-stars-and-sum-reviews')
  //         var emptyReviewEl = document.querySelector('#yotpo-cms-container .yotpo-main-widget .yotpo-bottomline-empty-state')
  //         if (emptyReviewEl) {
  //           var noReviewEl = document.querySelector('.ctg-yotpo-no-rating')
  //           document.querySelector('.yotpo-first-review-content').setAttribute('style', 'visibility: hidden;')
  //           if (noReviewEl == null) {
  //             noReviewEl = document.createElement('div')
  //             noReviewEl.className = 'ctg-yotpo-no-rating'
  //             document.querySelector('.yotpo-first-review-stars') && document.querySelector('.yotpo-first-review-stars').appendChild(noReviewEl)
  //           }
  //           noReviewEl.innerText = "This product has no review yet."
  //           return
  //         }
  //         if (starAndReviewEl == null) {
  //           setTimeout(starStringCallback, 100)
  //           return
  //         }
  //         var starSROnlyString = starAndReviewEl.querySelector('.yotpo-stars .sr-only') && starAndReviewEl.querySelector('.yotpo-stars .sr-only').innerText
  //         if (starSROnlyString !== null && starSROnlyString) {
  //           var starRating = parseFloat(starSROnlyString)
  //           if (starRating === NaN) {
  //             setTimeout(starStringCallback, 100)
  //             return
  //           }
  //           var starRatingEl = document.querySelector('.ctg-yotpo-rating')
  //           if (starRatingEl == null) {
  //             starRatingEl = document.createElement('div')
  //             starRatingEl.className = 'ctg-yotpo-rating'
  //             starAndReviewEl.appendChild(starRatingEl)
  //           }
  //           starRatingEl.innerText = `${starRating} out of 5 stars`
  //         } else {
  //           setTimeout(starStringCallback, 100)
  //           return
  //         }
  //       }
  //       starStringCallback()
  //       if (yotpo.getState() == 'ready') {
  //         starStringCallback()
  //       } else {
  //         yotpo.on('ready', starStringCallback)
  //       }
  //     })

  //   }, 10)

  // } else {
  //   window.vueEventHub && window.vueEventHub.$emit('enable-detail-page-product-review')
  // }

  Array.from(document.querySelectorAll('.cms-page-container vue-power-bar')).forEach(initPowerBar)
  function initPowerBar(el) {
    new Vue({
      el : el,
      render : h => h(CMSPowerBar, {
        props: {
          blockIndex : el.dataset.blockIndex,
          paragraph : el.dataset.paragraph,
          firstRowText : el.dataset.firstRowText,
          secondRowText : el.dataset.secondRowText
        }
      })
    })
  }

  {

    async function getComponent() {

      let [Selector, Listing, Selector2024, Listing2024] = await Promise.all([
        import(/* webpackChunkName: 'store-selector' */ './CMSStoreSelector.vue'),
        import(/* webpackChunkName: 'store-listing' */ './CMSStoreListing.vue'),
        import(/* webpackChunkName: 'store-selector-2024' */ './CMSStoreSelector2024.vue'),
        import(/* webpackChunkName: 'store-listing-2024' */ './CMSStoreListing2024.vue'),
      ])

      return [Selector, Listing, Selector2024, Listing2024]
    }

    if (document.querySelector('.cms-page-container store-selector')
      && document.querySelector('.cms-page-container store-listing')) {
      getComponent().then(components => {

        Array.from(document.querySelectorAll('.cms-page-container store-selector')).forEach(el => {
          new Vue({
            el : el,
            render : h => h(components[0], {})
          })
        })

        Array.from(document.querySelectorAll('.cms-page-container store-listing')).forEach(el => {
          new Vue({
            el : el,
            render : h => h(components[1], {})
          })
        })


      })
    }

    //web revamp 2024 version
    if (document.querySelector('.cms-page-container store-selector-2024')
      && document.querySelector('.cms-page-container store-listing-2024')) {
      getComponent().then(components => {
        Array.from(document.querySelectorAll('.cms-page-container store-selector-2024')).forEach(el => {
          new Vue({
            el: el,
            render: h => h(components[2], {})
          })
        })

        Array.from(document.querySelectorAll('.cms-page-container store-listing-2024')).forEach(el => {
          new Vue({
            el: el,
            render: h => h(components[3], {})
          })
        })

      })
    }

  }

  Array.from(document.querySelectorAll('.cms-page-container [data-scroll-animation-wrapper]')).forEach(el => new ScrollViewAnimation(el))
  Array.from(document.querySelectorAll('.cms-page-container [data-video-lottie-wrapper]')).forEach(el => new VideoLottie(el))

  const CMSCustomComponents = CMSComponentsConfig.components
  CMSCustomComponents.forEach((component)=>{

    async function getCMSCustomComponents() {
      let [CMSComponent2022] = await Promise.all([
        import(/* webpackChunkName: "[request]" */ './' + component['vueComponent'] + '.vue'),
      ])

      return [CMSComponent2022]
    }

    if (document.querySelector(`.cms-page-container ${component['cmsElement']}`)) {
      getCMSCustomComponents().then(components => {

        Array.from(document.querySelectorAll(`.cms-page-container ${component['cmsElement']}`)).forEach(el => {
          new Vue({
            el : el,
            render : h => h(components[0], {
              props: {
                componentProps: JSON.parse(el.dataset.componentProps),
                componentTemplate: el.dataset.componentTemplate,
                CDNPath
              }
            })
          })
        })

      })
    }
  })



}

window.CMSInit = CMSInit



// WEBPACK FOOTER //
// ./src/main.js